import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { ActivityRoutePage } from "../app/activityRoute";

export const Route = createFileRoute("/activity")({
  component: ActivityRoute,
});

function ActivityRoute(): JSX.Element {
  const search = Route.useSearch();
  return <ActivityRoutePage search={search} />;
}
